module.exports = __webpack_public_path__ + "79e4c268022d15c5ea975f39b8d6f15f.png";